import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\Auth\AuthenticatedSessionController::store
* @see app/Http/Controllers/Admin/Auth/AuthenticatedSessionController.php:35
* @route '/login'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/login',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Auth\AuthenticatedSessionController::store
* @see app/Http/Controllers/Admin/Auth/AuthenticatedSessionController.php:35
* @route '/login'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Auth\AuthenticatedSessionController::store
* @see app/Http/Controllers/Admin/Auth/AuthenticatedSessionController.php:35
* @route '/login'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Auth\AuthenticatedSessionController::store
* @see app/Http/Controllers/Admin/Auth/AuthenticatedSessionController.php:35
* @route '/login'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Auth\AuthenticatedSessionController::store
* @see app/Http/Controllers/Admin/Auth/AuthenticatedSessionController.php:35
* @route '/login'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Http\Controllers\Admin\Auth\AuthenticatedSessionController::destroy
* @see app/Http/Controllers/Admin/Auth/AuthenticatedSessionController.php:97
* @route '/logout'
*/
export const destroy = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: destroy.url(options),
    method: 'post',
})

destroy.definition = {
    methods: ["post"],
    url: '/logout',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Auth\AuthenticatedSessionController::destroy
* @see app/Http/Controllers/Admin/Auth/AuthenticatedSessionController.php:97
* @route '/logout'
*/
destroy.url = (options?: RouteQueryOptions) => {
    return destroy.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Auth\AuthenticatedSessionController::destroy
* @see app/Http/Controllers/Admin/Auth/AuthenticatedSessionController.php:97
* @route '/logout'
*/
destroy.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: destroy.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Auth\AuthenticatedSessionController::destroy
* @see app/Http/Controllers/Admin/Auth/AuthenticatedSessionController.php:97
* @route '/logout'
*/
const destroyForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Auth\AuthenticatedSessionController::destroy
* @see app/Http/Controllers/Admin/Auth/AuthenticatedSessionController.php:97
* @route '/logout'
*/
destroyForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(options),
    method: 'post',
})

destroy.form = destroyForm

/**
* @see \App\Http\Controllers\Admin\Auth\AuthenticatedSessionController::sso
* @see app/Http/Controllers/Admin/Auth/AuthenticatedSessionController.php:61
* @route '/sso'
*/
export const sso = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: sso.url(options),
    method: 'get',
})

sso.definition = {
    methods: ["get","head"],
    url: '/sso',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Auth\AuthenticatedSessionController::sso
* @see app/Http/Controllers/Admin/Auth/AuthenticatedSessionController.php:61
* @route '/sso'
*/
sso.url = (options?: RouteQueryOptions) => {
    return sso.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Auth\AuthenticatedSessionController::sso
* @see app/Http/Controllers/Admin/Auth/AuthenticatedSessionController.php:61
* @route '/sso'
*/
sso.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: sso.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Auth\AuthenticatedSessionController::sso
* @see app/Http/Controllers/Admin/Auth/AuthenticatedSessionController.php:61
* @route '/sso'
*/
sso.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: sso.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Auth\AuthenticatedSessionController::sso
* @see app/Http/Controllers/Admin/Auth/AuthenticatedSessionController.php:61
* @route '/sso'
*/
const ssoForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: sso.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Auth\AuthenticatedSessionController::sso
* @see app/Http/Controllers/Admin/Auth/AuthenticatedSessionController.php:61
* @route '/sso'
*/
ssoForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: sso.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Auth\AuthenticatedSessionController::sso
* @see app/Http/Controllers/Admin/Auth/AuthenticatedSessionController.php:61
* @route '/sso'
*/
ssoForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: sso.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

sso.form = ssoForm

/**
* @see \App\Http\Controllers\Admin\Auth\AuthenticatedSessionController::create
* @see app/Http/Controllers/Admin/Auth/AuthenticatedSessionController.php:24
* @route '/login'
*/
export const create = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

create.definition = {
    methods: ["get","head"],
    url: '/login',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Auth\AuthenticatedSessionController::create
* @see app/Http/Controllers/Admin/Auth/AuthenticatedSessionController.php:24
* @route '/login'
*/
create.url = (options?: RouteQueryOptions) => {
    return create.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Auth\AuthenticatedSessionController::create
* @see app/Http/Controllers/Admin/Auth/AuthenticatedSessionController.php:24
* @route '/login'
*/
create.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Auth\AuthenticatedSessionController::create
* @see app/Http/Controllers/Admin/Auth/AuthenticatedSessionController.php:24
* @route '/login'
*/
create.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: create.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Auth\AuthenticatedSessionController::create
* @see app/Http/Controllers/Admin/Auth/AuthenticatedSessionController.php:24
* @route '/login'
*/
const createForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Auth\AuthenticatedSessionController::create
* @see app/Http/Controllers/Admin/Auth/AuthenticatedSessionController.php:24
* @route '/login'
*/
createForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Auth\AuthenticatedSessionController::create
* @see app/Http/Controllers/Admin/Auth/AuthenticatedSessionController.php:24
* @route '/login'
*/
createForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

create.form = createForm

const AuthenticatedSessionController = { store, destroy, sso, create }

export default AuthenticatedSessionController